const bankColor = "#EDFAD7";
const bankSecondaryColor = "#4D7C0F";
const creditColor = "#F2E6FE";
const creditSecondaryColor = "#7E22CE";

export const data = {
  labels: ["06/23", "07/23", "08/23", "09/23", "10/23", "11/23"],
  datasets: [
    {
      data: [3348, 2906, 3014, 3276, 3105, 3330],
      backgroundColor: [bankColor],
      borderColor: [bankSecondaryColor],
      borderWidth: 2,
      maxBarThickness: 200,
    },
    {
      data: [2396, 1819, 2147, 2065, 2130, 1950],
      backgroundColor: [creditColor],
      borderColor: [creditSecondaryColor],
      borderWidth: 2,
      maxBarThickness: 200,
    },
  ],
};

export const options = {
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      color: (context) => {
        return context.datasetIndex === 0
          ? bankSecondaryColor
          : creditSecondaryColor;
      },
      anchor: "start",
      align: "start",
      offset: -20,
      font: {
        weight: "bold",
        size: 12,
      },
      formatter: (value) => value.toLocaleString(),
    },
  },
  responsive: true,
  maintainAspectRatio: false, 
  scales: {
    x: {
      stacked: true,
      grid: {
        display: false,
      },
      ticks: {
        display: true,
      },
      barPercentage: 1.0, 
      categoryPercentage: 0.9, 
    },
    y: {
      stacked: true,
      beginAtZero: true,
      grid: {
        display: false,
        drawBorder: false,
      },
      ticks: {
        display: false,
      },
    },
  },
};
